import React from "react";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap";
const TabsComponent = ({
  activeTab,
  toggleTab,
  tabs,
  loader,
  additionalText,
}) => {
  return (
    <div>
      <Nav
        tabs
        className="d-flex justify-content-start text-dark athlete_earning-nav"
      >
        {tabs.map((tab) => (
          <NavItem key={tab.id}>
            <NavLink
              className={
                activeTab === tab.id
                  ? "active active-tab py-2 bg-primary"
                  : "text-dark cursor-pointer py-2 "
              }
              onClick={() => {
                toggleTab(tab.id);
                tab.onClick();
              }}
            >
              <h2
                className={`${
                  activeTab === tab.id ? "text-white" : ""
                } tab_heading`}
              >
                {tab.title}
              </h2>
            </NavLink>
          </NavItem>
        ))}
        {additionalText && (
          <h4 className="mt-3 ml-2">
            {/* (Click notice to be taken to a New item) */}
          </h4>
        )}
      </Nav>
      <TabContent activeTab={activeTab} className="p-3 athlete-earning-content">
        {tabs.map((tab) => (
          <TabPane tabId={tab.id} key={tab.id}>
            {loader ? (
              <div className="text-center">
                <Spinner />
              </div>
            ) : (
              tab.content
            )}
          </TabPane>
        ))}
      </TabContent>
    </div>
  );
};
export default TabsComponent;
